import React, { useCallback, useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { DirectionsRenderer, DirectionsService, GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'
import './_map.scss'

// Ignoring coverage for Google map components as they cannot be mocked properly

function Map({ origin, destination, apiKey }) {
  const [directionResponse, setDirectionResponse] = useState();
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey
  });

  const markers = useMemo(() => {
    return [origin, destination].filter(p => !!p.lat && !!p.lng);
  }, [origin, destination])

  const fitBounds = useCallback((map) => {
    const bounds = new window.google.maps.LatLngBounds();
    markers.forEach(marker => {
      bounds.extend(marker);
    });
    map.fitBounds(bounds);
  }, []);

  //istanbul ignore next
  const handleDirectionsServiceCallback = useCallback(res => {
    if (res?.status === 'OK') {
      setDirectionResponse(res);
    }
  }, []);

  return isLoaded && !!markers[0] ? (
    <div className="map" data-testid="map">
      <GoogleMap
        mapContainerStyle={{
          blockSize: 140,
          inlineSize: '100%'
        }}
        onLoad={fitBounds}
        center={markers[0]}
      >
        {markers[1] && !directionResponse?.status ? (
          <>
            <DirectionsService
              callback={handleDirectionsServiceCallback}
              options={{
                origin: markers[0],
                destination: markers[1],
                travelMode: 'DRIVING'
              }}
            />
            
          </>
        ) : (
          <Marker position={markers[0]} />
        )}
        {directionResponse?.status === 'OK' && (
              //istanbul ignore next
              <DirectionsRenderer
                options={{ directions: directionResponse }}
              />
        )}
      </GoogleMap>
    </div>
  ) : null;
}

Map.propTypes = {
  origin: PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  destination: PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lng: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  apiKey: PropTypes.string.isRequired
}

export default Map
